import React from "react";
import { Box, Grid, Typography, useTheme, Button, Dialog } from "@mui/material";
import { useParams } from "react-router-dom";
import useDocumentById from "../../hooks/useDocumentById";
import BankTable from "../../components/Bank/table";
import getRequiredUserData from "../../utils/getBranchInfo";
import useUserClaims from "../../hooks/useUserClaims";
import { useAuth } from "../../contexts/AuthContext";
import { useState } from "react";
import { firestore } from "../../services/firebase";
import { collection, doc, where, query, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { ExportToExcel } from "../../utils/ExportToExcel";
import GivenAccessoriesToDeliveryGuyForm from "../../components/accessories_given_to_workers/create_accessories_given_to_delivery_guys_Form";
import BankAccountInfoTable from "../../components/Bank/account_info_table";
import GivenAccessoryToDeliveryGuyTable from "../../components/accessories_given_to_workers/given_accessory_table";
import AccessoryTypeTable from "../../components/accessories_given_to_workers/AccessoryTypeTable";

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const flexItemStyle = {
  flex: 9,
};

const flexItemStyles = {
  flex: 1,
};

const ViewAccessoriesGivenToDeliveryGuys = () => {
  const params = useParams();
  const theme = useTheme();
  const branchData = getRequiredUserData();
  let branchId = branchData.requiredId;
  const { user } = useAuth();
  const userClaims = useUserClaims(user);

  const [givenAccessories, setGivenAccessories] = useState([]);
  const [isAccessoryTypeDialogOpen, setIsAccessoryTypeDialogOpen] =
    useState(false);
  const handleOpenAccessoryTypeDialog = () =>
    setIsAccessoryTypeDialogOpen(true);
  const handleCloseAccessoryTypeDialog = () =>
    setIsAccessoryTypeDialogOpen(false);

  useEffect(() => {
    const getGivenAccessories = query(
      collection(firestore, "GivenAccessoriesToWorkers"),
      where("branchId", "==", params.id ? params.id : branchId)
    );

    const unsubscribe = onSnapshot(getGivenAccessories, (querySnapshot) => {
      const givenAccessory = [];
      querySnapshot.forEach((doc) => {
        givenAccessory.push({ id: doc.id, ...doc.data() });
      });
      setGivenAccessories(givenAccessory);
    });

    return () => unsubscribe();
  }, [params.id]);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Given Accessories To Delivery Guys</title>
        {/* <link rel="canonical" href="http://localhost:3000/" /> */}
        <meta name="description" content="Given Accessories To Delivery Guys" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100%",
          position: "relative",
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={userClaims.superAdmin ? 6 : 4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <Box flex="1">
              <Typography
                variant="h2"
                color={theme.palette.secondary[100]}
                fontWeight="bold"
                sx={{ mb: "5px" }}
              >
                Given Accessories To Delivery Guys
              </Typography>

              <Typography variant="h5" color={theme.palette.secondary[300]}>
                Entire list of Given Accessories To Delivery Guys
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={userClaims.superAdmin ? 6 : 5}
            sx={{
              display: "flex",
              justifyContent: userClaims.superAdmin ? "flex-end" : "center",
              alignItems: userClaims.superAdmin ? "flex-end" : "center",
            }}
          ></Grid>
          <Grid
            item
            xs={userClaims.superAdmin ? 0 : 3}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Box display="flex" gap={2}>
              <GivenAccessoriesToDeliveryGuyForm source="branches" />
              <Button
                variant="contained"
                color="secondary"
                onClick={handleOpenAccessoryTypeDialog}
              >
                Manage Accessory Types
              </Button>
            </Box>
            <Dialog
              open={isAccessoryTypeDialogOpen}
              onClose={handleCloseAccessoryTypeDialog}
              maxWidth="lg"
              fullWidth
            >
              <AccessoryTypeTable />
            </Dialog>
          </Grid>
        </Grid>

        <div style={containerStyle}>
          <div style={flexItemStyle}></div>
          <div style={flexItemStyles}>
            {userClaims.superAdmin ? (
              <ExportToExcel
                file={"branches"}
                branchId={branchData.requiredId}
                id={""}
                endpoint={"bank"}
                clear={true}
                name={`BankTable-Branch ${branchData.branchName}`}
              />
            ) : null}
          </div>
        </div>

        <Grid container spacing={2} marginTop={"10px"}>
          {givenAccessories.length > 0 ? (
            givenAccessories.map((givenAccessory, index) => (
              <Grid item xs={6} key={givenAccessory.id}>
                <GivenAccessoryToDeliveryGuyTable
                  givenAccessory={givenAccessory}
                />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "200px",
                  borderRadius: "8px",
                  mt: "20px",
                }}
              >
                <Typography variant="h4" color={theme.palette.secondary[300]}>
                  No accessories have been given to delivery guys yet.
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default ViewAccessoriesGivenToDeliveryGuys;
